module.exports = __webpack_public_path__ + "static/media/operationManagement.fa099bea.svg";